import { useEffect } from "react";
import Constants from "./Constants";

export function usePageTitle(title) {
  useEffect(() => {
    const siteName = Constants.SITE_NAME;
    document.title = title ? `${title} | ${siteName}` : siteName;
  }, [title]);
}
